import React , {useReducer , useState , useEffect} from 'react';
import FormError from '../components/form-error';
import RadioBox from '../components/radio-box';
import Recap from "../components/recapitulatif";
import logo from "../img/logo-bleu.webp";

const reducer = (state, action) => {
	switch (action.type) {
	case 'update':
		return { ...state, [action.key]: action.value };
	default:
		return state;
	}
};


export default function  QuestionsPreliminaires ( props ) {

	const [dataValid ,setDataValid] = useState(false);
	const [errors , setErrors] = useState([]);
	const {step , restart , simulationData} = props;

	const [state, dispatch] = useReducer(reducer, {
	    assuranceMaladieActivitePro: undefined,
	    assuranceMaladieResidantFr: undefined,
	    beneficeRsa: undefined,
	    etudiantFNAU: undefined,
	  });

    const questions = [
      { 
      	'question' :<>Vous avez une activité professionnelle <span className="font-bold">ET</span> bénéficiez de remboursements de vos
          dépenses de santé par l'assurance maladie</> , // Question text or JSX that goes inside the label section of the radio input.
         'model' : 'assuranceMaladieActivitePro', // State's name associated to the question's radio .
         'error' : "", // Error message for when user tries to pass the step without defining a value for the data .
      } ,
      { 
      	'question' : <>Vous résidez de façon stable et régulière en France <span className="font-bold">ET</span> bénéficiez de
          remboursements de vos dépenses de santé par l'assurance maladie</>, 
      	'model' : 'assuranceMaladieResidantFr',
      	'error' : "",
      } ,
      { 
      	'question' : <>Vous bénéficiez du <span className="font-bold">revenu de solidarité active</span> (RSA)</>, 
      	'model' : 'beneficeRsa',
      	'error' : "",
      } ,
      { 
      	'question' : <>Vous êtes étudiant <span className="font-bold">ET</span> vous bénéficiez de l'aide annuelle d'urgence du fonds
          national d’aide d’urgence aux étudiants (FNAU)</>, 
      	'model' : 'etudiantFNAU',
      	'error' : "",
      }
    ];

    
	const handleChangeAnswer = ( value , key )=>{
		dispatch({ type: 'update', key, value });
	};


	const isAnswersValid = ()=> {
		let valid = true;
		questions.forEach( (question)=>{
			if (state[question.model] === undefined){
				valid=false;
			}
		})
		return valid;
	};

	const setErrorsFeedback = ()=>{
		let errs = !dataValid ? ["Veuillez répondre à toutes les questions avant de passer à l’étape suivante."] : [];
		setErrors(errs);
	}

	const gotoNextStep = ()=>{
		setErrorsFeedback();
		if ( dataValid ) {
			let data = {};

			Object.keys(state).forEach((key)=>{
				data[key] = JSON.parse(state[key]);
			});

			props.setData( data );
			props.nextStep();
		}
	}

	const questionsVariable = Object.keys(state);

	useEffect (()=>{
		setDataValid(isAnswersValid());
	} , [state]);

	return <div className="sim-form min-height">
		<div className="questions-preliminaires">
			{  questions.map(
					(question , index) => {
						return (index < 1 || state[questionsVariable[index-1]] !== undefined  ) ? 
						<div className = "question">
							<RadioBox
							  key={index}
							  name={question.model}
							  model={state[question.model]}
							  options= {{
							  	"Oui" : true,
							  	"Non" : false
							  }}
							  handler = {handleChangeAnswer}
							>
								{question.question}
							</RadioBox>
						</div>:
						<></>
					}
				)
			}
		</div>
		
		<div className="buttons-container">
			<FormError errors={errors}/>
			<button onClick={gotoNextStep}
			 className={"button button-primary"+ (dataValid ? " active" : " disabled") }
			> Suivant</button>
			<span className='step'>Étape {step} / 7</span>
			<button onClick={restart} className="instep-restart-btn">Recommencer</button>
			<Recap data={simulationData}></Recap>
		</div> 
	<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</div>;

}
